import { useTranslation } from "@/hooks/localization/useTranslations";
import BaseOption from "./base-checkbox/BaseOption";
import PriceQuantity, { QuantityContor } from "./base-checkbox/PriceQuantity";

interface Props {
  checked: boolean;
  toggleOption: () => void;
  is_multi_select?: boolean;
  label: string;
  value?: number;
  disabled?: boolean;
  quantityContor?: QuantityContor;
  outOfStock?: boolean;
  disableRemoveAddon?: boolean;
  /** Sold out, yet still selectable so the shopper can request a restock reminder. */
  allowSelectOutOfStock?: boolean;
  /** Disabled by the backend — labelled "not available" instead of out of stock. */
  isDisabled?: boolean;
}

const CheckboxOption: React.FC<Props> = ({
  checked,
  toggleOption,
  is_multi_select,
  label,
  value,
  disabled = false,
  quantityContor,
  outOfStock,
  disableRemoveAddon,
  allowSelectOutOfStock,
  isDisabled,
}) => {
  const t = useTranslation();
  const disabledAndChecked = checked && disableRemoveAddon;
  const disableOption = disabled || outOfStock || disableRemoveAddon;

  return (
    <li
      onClick={
        checked && !disableRemoveAddon
          ? quantityContor
            ? (e) => e.stopPropagation()
            : toggleOption
          : !disableOption || allowSelectOutOfStock
          ? toggleOption
          : undefined
      }
      aria-disabled={
        (!checked && disableOption && !allowSelectOutOfStock) || undefined
      }
      className={`add-on ${
        checked ? "selected" : disableOption ? "disabled" : ""
      } ${disableRemoveAddon || allowSelectOutOfStock ? "disabled" : ""} ${
        (checked && quantityContor) || outOfStock
          ? "add-on-selected-qyantity-section"
          : ""
      }`}
    >
      <BaseOption
        selected={checked}
        disabled={disableOption}
        toggleOption={
          checked && quantityContor && !disableRemoveAddon
            ? toggleOption
            : () => {}
        }
        is_multi_select={is_multi_select!}
        label={label}
        disabledAndChecked={disabledAndChecked}
        allowSelectOutOfStock={allowSelectOutOfStock}
        muted={outOfStock}
      />
      {outOfStock && !value && !quantityContor && (
        <span className="add-on-out-of-stock-tag">
          {isDisabled ? t.product_disabled : t.variant_out_of_stock}
        </span>
      )}
      {(value || quantityContor) && (
        <PriceQuantity
          price={value}
          quantityContor={quantityContor}
          checked={checked}
          outOfStock={outOfStock!}
          disabled={disabledAndChecked}
          is_multi_select={is_multi_select!}
        />
      )}
    </li>
  );
};

export default CheckboxOption;
